import { current } from "@reduxjs/toolkit";
import { isAccountant, isAdmin } from "src/Common/function";
import api from "./api";

const getAll = (branch) => {
  return api.get("/api/user/getAll", { params: { branchId: branch } });
};

const deleteUser = (id) => {
  return api.post("/api/user/delete", { userId: id });
};

const restoreUser = (id) => {
  return api.post("/api/user/restore", { userId: id });
};

const updateUsers = (userData) => {
  return api.post("/api/user/update_users", { user_data: userData });
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const saveCurrentUser = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
};

const updateUser = (user) => {
  return api.post("/api/user/update_user", { user });
};

// Self-service partial update (own profile only — the backend rejects other
// userIds). Staff edits of other members go through updateUserPartialStaff.
const updateUserPartial = (userId, fields) => {
  return api.post("/api/user/update", { userId, fields });
};

// Staff edit of another member's basic fields — user:update-gated.
const updateUserPartialStaff = (userId, fields) => {
  return api.post("/api/user/update_staff", { userId, fields });
};

// Assign direct policies to a user — iam:updatePolicy-gated.
const assignPolicies = (userId, policies) => {
  return api.post("/api/user/assign_policies", { userId, policies });
};

// Assigning a role / branches are distinct IAM capabilities with their own
// endpoints (user:assignRole / user:assignBranch), separate from the generic
// partial update above.
const assignRole = (userId, roles) => {
  return api.post("/api/user/assign_role", { userId, roles });
};

const assignBranches = (userId, branches) => {
  return api.post("/api/user/assign_branches", { userId, branches });
};

const uploadAvatar = (file, id) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("file", file);

  return api.post("/api/user/file", formData, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};

const getUser = (userId) => {
  return api.get("/api/user/get-a-user-by-id", { params: { userId } });
};

// Own profile — auth-only endpoint (getUser is user:read-gated).
const getMe = () => {
  return api.get("/api/user/me");
};

const getUsers = (ids) => {
  return api.post("/api/user/get_users", { ids });
};
const getUsersByRole = (role, branch) => {
  return api.get("/api/user/getusersbyrole", { params: { role, branchId: branch.id } });
};

const getUsersByRoleWithBranchId = (role, branchId) => {
  return api.get("/api/user/getusersbyrole", { params: { role, branchId } });
};

// Lightweight picker for assignment dropdowns (WO/PO create, filters, calendar,
// report recipients). Hits an ungated endpoint so selecting an assignee doesn't
// require user:read; returns enabled users only, with display fields
// (id, name, email, avatar, isEnabled). Pass a null role to get all users.
const getUsersForAssign = (role, branchId) => {
  return api.get("/api/user/get_for_assign", { params: { role, branchId } });
};

const generateExcelForTeamManage = (branch) => {
  return api.get("/api/user/generate_excel_for_team_manage", { params: { branch } });
};

const downloadExcelForTeamManage = (branch) => {
  return api.get("/api/user/download_excel_for_team_manage", { params: { branchId: branch.id } });
};

const UserService = {
  getAll,
  deleteUser,
  restoreUser,
  updateUsers,
  getCurrentUser,
  uploadAvatar,
  saveCurrentUser,
  updateUser,
  updateUserPartial,
  updateUserPartialStaff,
  assignRole,
  assignBranches,
  assignPolicies,
  getUsers,
  getUser,
  getMe,
  getUsersByRole,
  getUsersByRoleWithBranchId,
  getUsersForAssign,
  generateExcelForTeamManage,
  downloadExcelForTeamManage,
};

export default UserService;
